export default units => [
  {
    title: 'ID',
    field: 'id',
    editable: 'never',
    width: 100,
  },
  {
    title: 'Tipo',
    field: 'type',
    lookup: {
      'Ambiente': 'Ambiente',
      'Trabalhadores': 'Trabalhadores',
    },
    width: 150,
  },
  {
    title: 'Subtipo',
    field: 'subtype',
    width: 150,
  },
  {
    title: 'Nome',
    field: 'name',
    width: 500,
  },
  {
    title: 'Unidade',
    field: 'unit_id',
    // `N/A` when there is no unit, which is what this column has been trying to
    // say since it was written. It used to say it as `lookup: { '': 'N/A' }`,
    // and that key can never have matched: `unit_id` is an INTEGER, null on
    // 6818 of 8723 rows, and material-table resolves a lookup as
    // `lookup[value]` - so `lookup[null]` asks for the key `"null"` and the
    // cell drew empty. Not a case that broke; a case that never worked.
    //
    // `emptyValue` is the library's own field for exactly this, and it is
    // chosen over a `render` on purpose: a render has to name `unit_id` by
    // hand, and a hand-written key that drifts from its column is the defect
    // shape that drew a dash on every row of five other columns this week.
    // This one names no field, so it cannot come apart from one.
    //
    // The `''` below stays. It matches nothing at display time - it never
    // could - but it is also the entry that puts an `N/A` option in the
    // edit select, and removing it would take away the only way to say a
    // condition has no unit. That is a different change from this one.
    emptyValue: 'N/A',
    lookup: { '': 'N/A', ...units },
    initialEditValue: null,
    width: 200,
  }
];
